/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_BlockInputs */

const en_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block more interruptive apps`)
};

const ar_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احظر المزيد من التطبيقات المُشتِّتة`)
};

const de_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blockieren Sie mehr unterbrechende Apps`)
};

const es_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquea las apps más intrusivas`)
};

const fr_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquer plus d'applications dérangeantes`)
};

const it_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocca più app interruttive`)
};

const ja_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邪魔なアプリをさらにブロック`)
};

const ko_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방해되는 앱 차단 한도 증가`)
};

const pt_br_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueie os aplicativos que mais te interrompem`)
};

const ru_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Блокируйте больше отвлекающих приложений`)
};

const th_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บล็อกแอปที่รบกวนได้มากขึ้น`)
};

const tr_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla rahatsız edici uygulamayı engelle`)
};

const zh_cn_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阻挡多个干扰 App`)
};

const zh_tw_app_block = /** @type {(inputs: App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阻擋多個干擾 App`)
};

/**
* | output |
* | --- |
* | "Block more interruptive apps" |
*
* @param {App_BlockInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const app_block = /** @type {((inputs?: App_BlockInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_BlockInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_block(inputs)
	if (locale === "ar") return ar_app_block(inputs)
	if (locale === "de") return de_app_block(inputs)
	if (locale === "es") return es_app_block(inputs)
	if (locale === "fr") return fr_app_block(inputs)
	if (locale === "it") return it_app_block(inputs)
	if (locale === "ja") return ja_app_block(inputs)
	if (locale === "ko") return ko_app_block(inputs)
	if (locale === "pt_br") return pt_br_app_block(inputs)
	if (locale === "ru") return ru_app_block(inputs)
	if (locale === "th") return th_app_block(inputs)
	if (locale === "tr") return tr_app_block(inputs)
	if (locale === "zh_cn") return zh_cn_app_block(inputs)
	return zh_tw_app_block(inputs)
});